import Cleave from 'cleave.js/react';
import React, { Component } from 'react';
import crdpagana from '../../../images/public/userarea/crdpagana.png';
import crdpaganb from '../../../images/public/userarea/crdpaganb.png';
import crdpaganj from '../../../images/public/userarea/crdpaganj.png';
import crdscia from '../../../images/public/userarea/crdscia.png';
import crdscib from '../../../images/public/userarea/crdscib.png';
import crdsciempty from '../../../images/public/userarea/crdsciempty.png';
import crdscij from '../../../images/public/userarea/crdscij.png';
import crdscis from '../../../images/public/userarea/crdscis.png';
import tr from '../../../libs/tr';
import close from '../../../images/public/registeration/clos.png';
import './CardPnl.css';
//import crdsciblock from '../../../images/public/userarea/crdsciblock.png';
import alerts from '../../../images/public/userarea/alerts.png';
import assistel from '../../../images/public/userarea/assistel.png';
import { activateEnablingList, getCardOptions, updateSkierPictureFetch } from '../../../libs/fetch';
//import WaitLoad from "../../../assets/components/loading/WaitLoad";
import { Alert, Modal, Toast } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import Cookies from 'universal-cookie';
import ReactFileReader from 'react-file-reader';

let cookies = new Cookies;

class CardPnl extends Component {

  constructor(props) {
    super(props);

    this.cardType = 0; // decide the format number of cards by type

    this.state = {
      isLoading: false,

      Adult: false, // True when the skier is Adult
      Senior: false, // True when the skier is Senior
      Junior: false, // True when the skier is Junior
      Baby: false, // True when the skier is Baby


      Block: props.Block,
      // Activate: false,
      // Active: true,
      Activate: props.Activate,
      Active: props.Active,
      Expired: props.Expired,
      Paganella: props.Paganella,
      /* TODO placeholders, to replace in i18n file */
      code: "30161472562509881850366",
      Telnumber: "+39 011 19 116 039",

      activeSkier: null,

      // loaded data check
      loadedData: false,

      cardImage: null,

      cardType: "test",
      borderBottomColor: 'rgba(255, 255, 255, 0.7)',//'rgba(255, 0, 0, 0.7)'
      isCardFormatValid: false,
      canAcceptEntry: true,//to disable card insertion when api is in progress
      cardStr: null,
      cardIndex: props.cardIndex,//is used to understand which card has been clicked
      selectedResorts: [],
      showChooseResorts: false,
      showUploadSkierPhoto: false,
      showErrorModal: false,
      errorModalMessage: '',
      skierPhoto: '',
      retryUploadPhoto: 0,
      cardOptions: null
    };

    console.log(props);

    this.cardPnlOnclick = this.cardPnlOnclick.bind(this);

  }

  componentDidMount() {
    this.setState({ activeSkier: this.props.activeSkier });

    this.checkCardType() // check card type
    // loadedData
    this.setState({ loadedData: true, code: this.props.activeSkier.code });
  }

  cardPnlOnclick(info, params) {
    localStorage.setItem('cardIndex', JSON.stringify(this.props.cardIndex));
    this.props.callback(info, params);
  }

  // return card type state for UI
  checkCardType = () => {
    let cardType = this.props.activeSkier.type.toLowerCase();
    let provider = this.props.activeSkier.provider.toLowerCase();

    console.log("CARD INFO: ", this.props.activeSkier);
    console.log("CARD INFO: ", cardType, provider);

    if (provider === "skidata") {
      this.setState({ provider: 0 });
      console.log("CARD INFO: provider == skidata");
      // this.state.cardImage = cardType.toLowerCase() == "baby" ? crdscib : cardType.toLowerCase() == "junior" ? crdscij : cardType.toLowerCase() == "senior" ? crdscis : crdscia
      switch (cardType.toLowerCase()) {
        case "baby":
          this.setState({ cardType: tr.t("Baby"), cardImage: crdscib });
          break;
        case "junior":
          this.setState({ cardType: tr.t("Junior"), cardImage: crdscij });
          break;
        case "senior":
          this.setState({ cardType: tr.t("Senior"), cardImage: crdscis });
          break;
        default:
          this.setState({ cardType: tr.t("Adulto"), cardImage: crdscia });
          break;
      }
    } else {
      console.log("CARD INFO: provider == Axess");
      this.setState({ provider: 1 });

      // this.state.cardImage = cardType.toLowerCase() == "baby" ? crdpaganb : cardType.toLowerCase() == "junior" ? crdpaganj : crdpagana
      switch (cardType.toLowerCase()) {
        case "baby":
          this.setState({ cardType: tr.t("Baby"), cardImage: crdpaganb });
          break;
        case "junior":
          this.setState({ cardType: tr.t("Junior"), cardImage: crdpaganj });
          break;
        // case "senior":
        //     this.setState({ cardType: tr.t("Senior"), cardImage: crdscis });
        //     break;
        default:
          this.setState({ cardType: tr.t("Adulto"), cardImage: crdpagana });
          break;
      }
    }
  }



  validateCard = async (cardStr) => {
    this.setState({ isLoading: true });
    try {
      const response = await getCardOptions(this.state.activeSkier.card_id, cardStr);
      console.log("[CardPnl] getCardOptions @response: ", response);
      this.setState({ canAcceptEntry: true, isLoading: false });
      if (response && response.status === "success") {
        //Card can be assigned to the user.
        this.setState({
          cardStr: cardStr,
          borderBottomColor: 'rgba(255, 255, 255, 0.7)',
          isCardFormatValid: true,
          cardOptions: response,
        });
        return;
      } else {
        this.setState({
          borderBottomColor: 'rgba(255, 0, 0, 0.7)',
          isCardFormatValid: false,
        });
        console.log("this.cardPnlOnclick('cardValidationError');", response && response.message);
        this.cardPnlOnclick('cardValidationError', (response && response.message) || 'Validation failed');
        //Card cannot be assigned to the user.
      }
    } catch (error) {
      this.setState({ canAcceptEntry: true, isLoading: false });
      this.cardPnlOnclick('cardValidationError', 'Error validating card');
    }
  }

  onSkidataCardNumberChange = (event) => {
    let rawVal = event.target.rawValue;
    let formattedVal = event.target.value;
    if (rawVal.length > 22) {
      this.setState({ canAcceptEntry: false });
      console.log(formattedVal);
      let cardStr = formattedVal.replace(/\s/g, '');//removing spaces for restcall
      console.log(cardStr);
      this.validateCard(cardStr);
    } else {
      this.setState({
        borderBottomColor: 'rgba(255, 255, 255, 0.7)',
        isCardFormatValid: false,
      });
    }

  }

  onAxessCardNumberChange = (event) => {
    let rawVal = event.target.rawValue;
    let formattedVal = event.target.value;
    if (rawVal.length > 13) {
      this.setState({ canAcceptEntry: false });
      console.log(formattedVal);
      let cardStr = formattedVal.replace(/\s/g, '');//removing spaces for restcall
      console.log(cardStr);
      this.validateCard(cardStr);
    } else {
      this.setState({
        borderBottomColor: 'rgba(255, 255, 255, 0.7)',
        isCardFormatValid: false,
      });
    }

  }

  getOptions = async () => {
    try {
      const cardOptions = await getCardOptions(this.state.activeSkier.card_id, this.state.cardStr);
      if (cardOptions.status === "success") {
        this.setState({ cardOptions: cardOptions });
      }
      return cardOptions;
    } catch (error) {
      this.setState({ showErrorModal: true, errorModalMessage: error.toString() });
    }
  }

  activateCard = async () => {
    // Use stored card options from validation, or fetch fresh if not available
    var cardOptions = this.state.cardOptions;
    if (!cardOptions) {
      cardOptions = await this.getOptions();
    }
    console.log("Card Options: ", cardOptions);
    if (!cardOptions || cardOptions.status == "fail") {
      this.setState({ active: false, showErrorModal: true, errorModalMessage: (cardOptions && cardOptions.message) || 'Error fetching card options' });
      return;
    }

    const preselectedIds = cardOptions.data.enablings
      .filter(function(enabling) { return enabling.statusOnCard.preselected === 1; })
      .map(function(enabling) { return enabling.id; });
    const maxNum = cardOptions.data.maxNum;
    this.setState({ selectedResorts: preselectedIds.slice(0, maxNum) });

    if (cardOptions.status == "success" && cardOptions.data.allSupported) {
      if (this.state.activeSkier.picture) {
        const activatePayload = {
          nkey: this.state.cardStr,
          cardId: this.state.activeSkier.card_id,
          special: 1,
          choices: [],
          photoLoaded: true,
          photoValidated: true,
          forced: 0,
        };

        activateEnablingList(this, activatePayload).then(function(response) {
          if (response.status == "fail") {
            this.setState({ showErrorModal: true, errorModalMessage: response.message });
          } else {
            window.location.reload();
          }
        }.bind(this));
      } else {
        this.setState({ showUploadSkierPhoto: true });
      }
    } else if (cardOptions.status == "success" && !cardOptions.data.allSupported) {
      this.setState({ showChooseResorts: true });
    } else {
      this.setState({ showErrorModal: true, errorModalMessage: cardOptions.message || 'Activation error' });
    }
  }



  onResortChange = (event) => {
    const { selectedResorts } = this.state;
    const { value: resortId, checked } = event.target;
    const { maxNum } = this.state.cardOptions;
    const resorIdNumber = parseInt(resortId);
    console.log("Resort ID: ", resorIdNumber);
    console.log("Checked: ", checked);

    if (checked) {
      if (selectedResorts.length < maxNum) {
        this.setState({ selectedResorts: [...selectedResorts, resorIdNumber] }, () => {
          console.log("Selected Resorts: ", this.state.selectedResorts);
        });
      } else {
        this.setState({ selectedResorts: [...selectedResorts.slice(0, -1), resorIdNumber] }, () => {
          console.log("Selected Resorts: ", this.state.selectedResorts);
        });
      }
    } else {
      this.setState({ selectedResorts: selectedResorts.filter((id) => id !== resorIdNumber) }, () => {
        console.log("Selected Resorts: ", this.state.selectedResorts);
      });
    }
  };

  onCloseChooseResorts = () => {
    this.setState({ showChooseResorts: false });
  }

  onCloseUploadSkierPhoto = () => {
    this.setState({ showUploadSkierPhoto: false });
  }

  onNextChooseResorts = async () => {
    const choices = this.state.cardOptions.data.enablings.filter((item) => this.state.selectedResorts.includes(item.id)).map((item) => item.name).join(', ');
    if (this.state.activeSkier.picture) {
      const activatePayload = {
        nkey: this.state.cardStr,
        cardId: this.state.activeSkier.card_id,
        special: 1,
        choices,
        photoLoaded: 1,
        photoValidated: 0,
        forced: 1,
      };
      const activated = await activateEnablingList(this, activatePayload);
      console.log("Activated: ", activated);
      if (activated.status === "fail") {
        this.setState({ showChooseResorts: false, showErrorModal: true, errorModalMessage: activated.message });
      } else {
        this.setState({ showChooseResorts: false });
        window.location.reload();
      }
    } else {
      this.setState({ showChooseResorts: false, showUploadSkierPhoto: true });
    }
  }

  onNextUploadSkierPhoto = async () => {
    try {
      let profileParams = {
        image: this.state.skierPhoto.split(',')[1],
        linked_user_id: this.state.activeSkier.id
      }
      const updated = await updateSkierPictureFetch(this, profileParams);
      this.setState({ photoLoaded: updated.status === 'success' });
      console.log('Updated photo', updated);
      const activatePayload = {
        nkey: this.state.cardStr,
        cardId: this.state.activeSkier.card_id,
        special: 1,
        choices: this.state.cardOptions.data.enablings.filter((item) => this.state.selectedResorts.includes(item.id)).map((item) => item.name).join(', '),
        photoLoaded: updated.status === 'success',
        photoValidated: false,
        forced: updated.status === 'success' ? 0 : 1,
      };

      const activated = await activateEnablingList(this, activatePayload);
      console.log("Activated: ", activated);
      if (activated.status === "fail") {
        this.setState({ showUploadSkierPhoto: false, showErrorModal: true, errorModalMessage: activated.message });
      } else {
        this.setState({ showUploadSkierPhoto: false });
        window.location.reload();
      }
    } catch (error) {
      this.setState({ showUploadSkierPhoto: false, showErrorModal: true, errorModalMessage: error.toString() });
    }
  }

  openCameraOrAttachFile = () => {
    const choice = window.prompt("Type 'camera' to open the camera or 'file' to attach a file:");

    if (choice === "camera") {
      // Open the camera
      navigator.mediaDevices.getUserMedia({ video: true })
        .then((stream) => {
          // Create a video element to display the stream
          const videoElement = document.createElement("video");
          videoElement.srcObject = stream;
          videoElement.autoplay = true;
          videoElement.style.position = "fixed";
          videoElement.style.top = "0";
          videoElement.style.left = "0";
          videoElement.style.width = "100%";
          videoElement.style.height = "100%";
          document.body.appendChild(videoElement);

          // Add a button to stop the camera
          const stopButton = document.createElement("button");
          stopButton.textContent = "Stop Camera";
          stopButton.style.position = "fixed";
          stopButton.style.top = "10px";
          stopButton.style.right = "10px";
          document.body.appendChild(stopButton);

          stopButton.onclick = () => {
            stream.getTracks().forEach(track => track.stop());
            document.body.removeChild(videoElement);
            document.body.removeChild(stopButton);
          };
        })
        .catch((error) => {
          console.error("Error accessing camera:", error);
          alert("Could not access camera. Please check your permissions.");
        });
    } else if (choice === "file") {
      // Open file input
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.style.display = "none";

      fileInput.onchange = (event) => {
        const file = event.target.files[0];
        if (file) {
          alert(`Selected file: ${file.name}`);
        }
      };

      document.body.appendChild(fileInput);
      fileInput.click();
      document.body.removeChild(fileInput);
    } else {
      alert("Invalid choice. Please type 'camera' or 'file'.");
    }
  };

  updateSkierPhoto = (files) => {
    this.setState({ skierPhoto: files.base64 });
  }


  render() {
    return (
      <div className="cardPnl">
        <Modal show={this.state.showUploadSkierPhoto} onHide={this.onCloseUploadSkierPhoto} size='lg'>
          <Modal.Body className="modal-main-body" style={{ backgroundColor: '#161733', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} className="modal-exit" onClick={this.onCloseUploadSkierPhoto}>
              <img src={close} className="img-fluid" style={{ width: 30, height: 30 }} />
            </div>
            <h5 style={{ color: 'white', textAlign: 'center' }}>{tr.t("UploadSkierPhotoTitle")}</h5>
            <div className="sn_upload__square mx-auto mt-lg-4" style={{ width: 200, height: 200, }}>
              <ReactFileReader base64={true} handleFiles={this.updateSkierPhoto}>
                <a><img style={{ borderRadius: 20, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} src={this.state.skierPhoto ? (this.state.skierPhoto) : (require('../../../images/public/userarea/profilec.png'))} className="img-fluid" /></a>
              </ReactFileReader>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 50, marginBottom: 30 }}>
              <button className="sn_btn sn_minibutton" onClick={this.onNextUploadSkierPhoto}>{tr.t("ActivateCard")}</button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showErrorModal} onHide={function() { this.setState({ showErrorModal: false }); }.bind(this)} size='lg'>
          <Modal.Body className="modal-main-body" style={{ backgroundColor: '#161733', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} className="modal-exit" onClick={function() { this.setState({ showErrorModal: false }); }.bind(this)}>
              <img src={close} className="img-fluid" style={{ width: 30, height: 30 }} />
            </div>
            <h5 style={{ color: 'white', textAlign: 'center', marginTop: 20 }}>{tr.t("Attention")}</h5>
            <p style={{ color: 'white', textAlign: 'center', marginTop: 20, marginBottom: 20 }}>{this.state.errorModalMessage}</p>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 20, marginBottom: 30 }}>
              <button className="sn_btn sn_minibutton" onClick={function() { this.setState({ showErrorModal: false }); }.bind(this)}>{tr.t("Ok")}</button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showChooseResorts} onHide={this.onCloseChooseResorts} size='xl'>
          <Modal.Body className="modal-main-body" style={{ backgroundColor: '#161733', justifyContent: 'space-between' }}>
            <div style={{ marginBottom: 20 }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} className="modal-exit" onClick={this.onCloseChooseResorts}>
                <img src={close} className="img-fluid" style={{ width: 30, height: 30 }} />
              </div>
              <h4 style={{ color: 'white', textAlign: 'center' }}>{tr.t("WhereDoYouGoSkiing")}</h4>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <p style={{ color: 'white' }}>{`Card:`}<b style={{ color: 'white' }}>{this.state.cardStr ? this.state.cardStr : ''}</b></p>
              <p style={{ textAlign: 'center', color: 'white' }}>{tr.t("LimitedResortsNumber")}</p>
              <p style={{ textAlign: 'center', color: 'white' }}>{`${tr.t("LimitedResortsRequest")} ${this.state.cardOptions && this.state.cardOptions.data.maxNum})`}</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              {
                this.state.cardOptions && this.state.cardOptions.data.enablings.map((enabling, index) => {
                  console.log('Enabling: ', enabling);
                  return (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', opacity: !enabling.statusOnCard.compatible ? 0.5 : 1 }} key={index} className="enabling-item">
                      <input disabled={!enabling.statusOnCard.compatible} style={{ marginRight: 20, color: 'white' }} type="checkbox" name="enabling" checked={this.state.selectedResorts.includes(enabling.id)} value={enabling.id} onChange={this.onResortChange} />
                      <label style={{ color: 'white' }}>{enabling.commercialName}</label>
                    </div>
                  )
                })
              }
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20, marginBottom: 20 }}>
              <button className="sn_btn sn_minibutton" onClick={this.onNextChooseResorts}>{tr.t("Next")}</button>
            </div>
          </Modal.Body>
        </Modal>
        {
          this.state.loadedData && <div>

            {/* ACTIVATE #notes: When user says I already have a card. The provider is known here */}
            {this.state.Activate &&
              <div>
                <div className="cardType mb-4">
                  <img src={crdsciempty} className="img-fluid sn_shadow" />
                </div>
                <div className="disPnl">
                  <div className="lineD d-flex align-items-center">
                    {tr.t("Cardactivate")}
                    <div className="alertsD ml-3">
                      <img src={alerts} className="img-fluid" />
                    </div>
                  </div>
                  <div className="lineI mb-3">

                    {/* <input type="text" name="number" placeholder={tr.t("Insert")} className="txtStyleID" maxLength="50" /> */}
                    {this.state.provider === 0 && <Cleave
                      className={this.state.isCardFormatValid ? "txtStyleID_ticked" : "txtStyleID"}
                      style={{ borderBottomColor: this.state.borderBottomColor, borderBottomWidth: 2 }}
                      options={{
                        delimiters: ['-', ' ', ' ', ' ', ' ', '-'],
                        blocks: [2, 4, 4, 4, 4, 4, 1],
                        uppercase: true
                      }}
                      onChange={this.onSkidataCardNumberChange}
                      disabled={!this.state.canAcceptEntry}
                      placeholder={tr.t("NumberCard")}
                    />}
                    {this.state.provider === 1 && <Cleave
                      className={this.state.isCardFormatValid ? "txtStyleID_ticked" : "txtStyleID"}
                      style={{ borderBottomColor: this.state.borderBottomColor, borderBottomWidth: 2 }}
                      options={{
                        delimiters: ['-', '-'],
                        blocks: [8, 3, 3],
                        uppercase: true
                      }}
                      onChange={this.onAxessCardNumberChange}
                      disabled={!this.state.canAcceptEntry}
                      placeholder={tr.t("Insert") + " "}
                    />}
                    {this.state.isLoading && <ReactLoading className="loading-cardpnl" type={'spin'} delay={15} width={20} />}
                  </div>
                  <button disabled={!this.state.isCardFormatValid} className="sn_btn sn_minibutton" onClick={this.activateCard}>{tr.t("Activatecard")}</button>
                </div>
              </div>
            }
            {/*After ACTIVATE #notes: card images are changed*/}
            {this.state.Active &&
              <div>
                <div>
                  <div className="cardType mb-5">
                    <img src={this.state.cardImage} className="img-fluid sn_shadow" />
                  </div>
                  <div className="actPnl">
                    <div className="row mb-3">
                      <div className="col-auto titlePnlc">
                        <div className="lineCIT1">{tr.t("Number")}</div>
                      </div>
                      <div className="col insertedPnlc">
                        <div className="lineCI1">
                          {this.state.activeSkier.code}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col-auto titlePnlc">
                        <div className="lineCIT2">{tr.t("Type")}</div>
                      </div>
                      <div className="col insertedPnlc">
                        <div className="lineCI2">
                          {this.state.cardType}
                        </div>
                      </div>
                    </div>

                    <button className="sbtn3" onClick={() => this.cardPnlOnclick("blockButton")}>{tr.t("Blockcard")}</button>
                  </div>
                </div>
              </div>
            }
            {/* Block */}



            {this.props.Block ?
              <div>
                <div className="blockPnl">
                  <div className="cardTypeb mb-5">
                    <img src={this.state.cardImage} className="img-fluid grayScale sn_shadow" />
                  </div>
                  <div className="blkPnl">
                    <div className="lineD d-flex align-items-center mb-3">
                      {tr.t("Cardblocked")}
                      <div className="alertsD ml-3">
                        <img src={alerts} className="img-fluid" />
                      </div>
                    </div>
                    <div className="lineR mb-2">{tr.t("Unblockcard")}</div>
                    <div className="lineH d-flex align-items-center mb-4">
                      <div className="telB mr-2">
                        <img src={assistel} className="img-fluid" />
                      </div>
                      {tr.t("Telnumber")}
                    </div>

                    <div className="actPnlb">
                      <div className="row mb-3">
                        <div className="col-auto titlePnlc">
                          <div className="lineCIT1">{tr.t("Number")}</div>
                        </div>
                        <div className="col insertedPnlc">
                          <div className="lineCI1">
                            {this.state.activeSkier.code}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-auto titlePnlc">
                          <div className="lineCIT2">{tr.t("Type")}</div>
                        </div>
                        <div className="col insertedPnlc">
                          <div className="lineCI2">
                            {this.state.cardType}
                          </div>
                        </div>
                      </div>
                    </div>


                    {/* The following items are hidden at this moment according to Veronica & Serena */}
                    {/* <button className="sbtn4" onClick={() => this.cardPnlOnclick("replaceCard")}>{tr.t("Replacecard")}</button> */}
                    {/* <div className="lineC" >{tr.t("Cost")}</div> */}
                  </div>
                </div>
              </div> : null

              // <div>
              //     <div className="blockPnl">
              //         <div className="cardTypeb">
              //             <img src={this.state.cardImage} className="responsiveCardb grayScale" />
              //         </div>
              //         <div className="blkPnl">
              //             <div className="lineD d-flex align-items-center">
              //                 {tr.t("Cardblocked")}
              //                 <div className="alertsD">
              //                     <img src={alerts} className="img-fluid" />
              //                 </div>
              //             </div>
              //             <div className="lineR">{tr.t("Unblockcard")}</div>
              //             <div className="lineH">
              //                 <div className="telB">
              //                     <img src={assistel} className="img-fluid" />
              //                 </div>
              //                 {tr.t("Telnumber")}
              //             </div>
              //             <div className="actPnlb">
              //                 <div className="titlePnlc">
              //                     <div className="lineCIT1">{tr.t("Number")}</div>
              //                     <div className="lineCIT2">{tr.t("Type")}</div>
              //                 </div>
              //                 <div className="insertedPnlc">
              //                     <div className="lineCI1">
              //                         {this.state.activeSkier.code}
              //                     </div>
              //                     <div className="lineCI2">
              //                         {this.state.cardType}
              //                     </div>
              //                 </div>
              //             </div>
              //             {/* The following items are hidden at this moment according to Veronica & Serena */}
              //             {/* <button className="sbtn4" onClick={() => this.cardPnlOnclick("replaceCard")}>{tr.t("Replacecard")}</button> */}
              //             {/* <div className="lineC" >{tr.t("Cost")}</div> */}
              //         </div>
              //     </div>
              // </div> : null
            }
          </div>
        }
      </div >
    );
  }
}

export default CardPnl;



// WEBPACK FOOTER //
// ./src/assets/components/panel/CardPnl.js